import muster from '@dbk-legacy/muster';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';

import { DOCSIGN_API_ERROR_CODES } from '../constants';
import $ from 'npm-zepto';

import downloadBase64AsPdf from './utils/base64-to-pdf-file-download';
import { encode } from 'base-64';


const DOCSIGN_PATH = 'roster.data.docsign';
const EMPTY_STRING = "empty";




export default () =>
  muster()
    .path('docsigncenter.getDocumentTypeList', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const banner = 'eSignature';
        const inputs = `${banner}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getDocumentTypeList["${inputs}"]["${guidStr}"]`));

        isValidJsonString(result).then(async (getDocumentTypeListResponse) => {
          if (getDocumentTypeListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
            || getDocumentTypeListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsigncenter.documentTypeList', getDocumentTypeListResponse.data);
          } else {
            await set('docsigncenter.documentTypeList', EMPTY_STRING);
          }
        }).catch(async (error) => {
          alert('Response json is not valid ' + error);
        });
      }
    })

    .path('docsigncenter.getEligiblePfList', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const banner = 'eSignature';
        const inputs = `${banner}`;
        const [result] = await getValues(get(`${DOCSIGN_PATH}.getEligiblePfList["${inputs}"]["${guidStr}"]`));

        isValidJsonString(result).then(async (getEligiblePfListResponse) => {
          if (getEligiblePfListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
            || getEligiblePfListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsigncenter.eligiblePfList', getEligiblePfListResponse.data);
          } else if (getEligiblePfListResponse.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
            || getEligiblePfListResponse.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
            await set('docsigncenter.eligiblePfList', EMPTY_STRING);
          }
        }).catch(async (error) => {
          alert('Response json is not valid ' + error);
        });

      }
    })
    .path('docsigncenter.getEligibleClientList', {
      call: async ({ req }, { get, set, call }) => {
        const pfId = "F" + req.args[0];
        // "3061678.01", "3003779.01", "3061678.01", "6004477.01", "8052425.01"
        const guidStr = Guid();
        const inputs = `${pfId}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getEligibleClientList["${inputs}"]["${guidStr}"]`));

        isValidJsonString(result).then(async (getEligibleClientListResponse) => {
          if (getEligibleClientListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
            || getEligibleClientListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsigncenter.eligibleClientList', getEligibleClientListResponse.data);
          } else if (getEligibleClientListResponse.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
            || getEligibleClientListResponse.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
            await set('docsigncenter.eligibleClientList', EMPTY_STRING);
          }
        }).catch(async (error) => {
          alert('Response json is not valid ' + error);
        });

      }
    })
    .path('docsigncenter.getDocumentListForAdmin', {
      call: async ({ req }, { get, set, call }) => {
        // await set('docsigncenter.documentListForAdmin', undefined);

        const guidStr = Guid();
        // const banner = 'eSignature';
        // const inputs = `${banner}`;
        // {"userId":"AP060762", "pfIds":["6000129.01"], "pageNumber":"0", "pagesize":"5", "sortColumn":"pf_id", "sortOrder":"ASC" }
        var selectedPortfolioData = await getValues(get('app.user.selectedPortfolioData'));
        var [isAdminUser] = await getValues(get('auth.isAdminUser'));

        let newPfIds = '';

        if (isAdminUser) {
          newPfIds = "Fall";
        } else {
          let pfId = pfId = selectedPortfolioData[0].id;
          if (selectedPortfolioData[0].relId !== null && selectedPortfolioData[0].relId !== undefined) {
            pfId = selectedPortfolioData[0].relId;
          }
          newPfIds = "F" + pfId.toString().replace('-', '.');
        }

        var pageNumber = "F" + req.args[0];
        var pagesize = "F" + req.args[1];
        const sortColumn = req.args[2];
        const sortOrder = req.args[3];
        const excelExportFlag = req.args[4];
        const filterOptionsObj = req.args[5];
        const filterOptions = encode(JSON.stringify(filterOptionsObj));

        const inputs = `${newPfIds}#@#${pageNumber}#@#${pagesize}#@#${sortColumn}#@#${sortOrder}#@#${excelExportFlag}#@#${filterOptions}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getDocumentListForAdmin["${inputs}"]["${guidStr}"]`));
        let response = EMPTY_STRING;

        if (result == null) {
          response = EMPTY_STRING;
        } else {
          isValidJsonString(result).then(async (res) => {
            if (res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              response = res.data;
            } else if (res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
              // "Data not found in database",
              response = EMPTY_STRING;
            } else {
              alert('Response json returned non-success response');
            }

            if (excelExportFlag === true) {
              await set('docsigncenter.documentListForAdminAll', response);
            } else {
              await set('docsigncenter.documentListForAdmin', response);
            }
          }).catch(async (error) => {
            alert('Response json is not valid ' + error);
          });
        }
      }
    })
    .path('docsigncenter.localUpdateDocumentListForAdmin', {
      call: async ({ req }, { get, set, call }) => {
        if (req.args[0]) {
          await set('docsigncenter.documentListForAdmin', EMPTY_STRING);
          await set('docsigncenter.documentListForAdmin', req.args[0]);
        }
      }
    })
    .path('docsigncenter.manageUserDocument', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        // const banner = 'eSignature';
        // const inputs = `${banner}`;

        const dsDocId = "F" + req.args[0];
        const action = req.args[1];
        const pfId = "F" + req.args[2];
        const branchCode = "F" + req.args[3];
        const inputs = `${dsDocId}#@#${action}#@#${pfId}#@#${branchCode}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.manageUserDocument["${inputs}"]["${guidStr}"]`));

        isValidJsonString(result).then(async (responseJson) => {
          if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
            || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsigncenter.userDocumentStatus', true);
          } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
            || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
            // "UserId or PfId or DocumentId does not exist",
            await set('docsigncenter.userDocumentStatus', responseJson.message);
          } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.TABLE_UPDATE_FAILED
            || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.TABLE_UPDATE_FAILED_INT) {
            // "System error",
            await set('docsigncenter.userDocumentStatus', responseJson.message);
          } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.NOT_PENDING_AND_PULLBACK
            || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.NOT_PENDING_AND_PULLBACK_INT) {
            //document can't be pulled back
            await set('docsigncenter.userDocumentStatus', responseJson.message);
          }
        }).catch(async (error) => {
          alert('Response json is not valid ' + error);
        });
      }
    })
    .path('docsigncenter.resetUserDocumentStatus', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.userDocumentStatus', undefined);
      }
    })
    .path('docsigncenter.viewDocumentForAdmin', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.downloadCompleteStatus', undefined);

        const dmsDocId = req.args[0];
        const docName = req.args[1];
        const [loggedInUserId] = await getValues(get(['auth.userId']));
        var [envitronmentUrl, apiversion, defaultEnvironment] = await getValues(
          get([
            'settings.currentEnvironment.remoteUrl',
            'app.config.apiverion',
            'settings.defaultEnvironment'
          ])
        );
        const [authHeader] = await getValues(get(['auth.authHeader']));
        let downloadUrl, body;

        if (defaultEnvironment === "local" || defaultEnvironment === "static") {
          //Testing APAC UAT3
          downloadUrl = "https://sinasebanku2.sg.db.com:8243/digisign/1.0/previewDsDoc";
          // Testing APAC DEV
          // downloadUrl = "https://pwpbod01.sg.db.com:8243/digisign/1.0/previewDsDoc";
          // Testing APAC DEV 2
          //downloadUrl = "https://sinasebankd11.sg.db.com:8243/digisign/1.0/previewDsDoc";
          // TESTING local machine 
          // downloadUrl = "http://10.2.2.168:18080/previewDsDoc";
          // body = {
          //   docId: "70B98666-0000-C211-A41A-8A904E4ED2E9",
          //   userId: "AP060762"
          // }
          body = {
            docId: dmsDocId,
            userId: loggedInUserId
          }
        } else {
          downloadUrl = envitronmentUrl + '/digisign/' + apiversion + '/previewDsDoc';
          body = {
            docId: dmsDocId,
            userId: loggedInUserId
          }
        }
        var x = new XMLHttpRequest();
        const fileName = docName + '.pdf';
        x.open('POST', downloadUrl, true);
        x.setRequestHeader('Authorization-Token', authHeader);
        //ENABLE for LOCAL testing
        // x.setRequestHeader('Authorization', 'Bearer 500b3441f2d85ef7ea618566aa3fd4f5');
        x.setRequestHeader('content-type', 'application/json; charset=utf-8');
        x.setRequestHeader(
          'Content-Disposition',
          'inline; filename=' + dmsDocId + '.pdf'
        );
        x.setRequestHeader(
          'Cache-Control',
          'no-cache, no-store, must-revalidate'
        );
        x.setRequestHeader('Pragma', 'no-cache');
        x.setRequestHeader('Expires', '0');
        x.responseType = 'text';
        x.onload = async function (e) {
          const jsonResponse = JSON.parse(x.responseText);
          if (jsonResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
            || jsonResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            downloadBase64AsPdf(jsonResponse.data, fileName);
            await set('docsigncenter.downloadCompleteStatus', true);
          } else if (jsonResponse.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_FAILED_INT
            || jsonResponse.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_FAILED) {
            await set('docsigncenter.downloadCompleteStatus', jsonResponse.message);
          } else if (jsonResponse.returnCode === DOCSIGN_API_ERROR_CODES.INTERNAL_SERVER_ERROR_INT
            || jsonResponse.returnCode === DOCSIGN_API_ERROR_CODES.INTERNAL_SERVER_ERROR) {
            await set('docsigncenter.downloadCompleteStatus', "error");
          }
        };
        x.onerror = async function () {
          await set('docsigncenter.downloadCompleteStatus', "error");
        };
        x.onreadystatechange = async function () {
          if (x.readyState === 4) {   //if complete
            if (x.status === DOCSIGN_API_ERROR_CODES.INTERNAL_SERVER_ERROR_INT
              || x.status === DOCSIGN_API_ERROR_CODES.INTERNAL_SERVER_ERROR) {
              await set('docsigncenter.downloadCompleteStatus', "error");
            }
          }
        }
        x.send(JSON.stringify(body));
      }
    })
    .path('docsigncenter.uploadDocument', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.documentUploadStatus', undefined);

        var body = req.args[0];
        var [envitronmentUrl, apiversion, defaultEnvironment] = await getValues(
          get([
            'settings.currentEnvironment.remoteUrl',
            'app.config.apiverion',
            'settings.defaultEnvironment'
          ])
        );
        const [authHeader] = await getValues(get(['auth.authHeader']));
        const [userId] = await getValues(get(['auth.userId']));

        body['userId'] = userId;

        let uploadUrl;

        if (defaultEnvironment === "local" || defaultEnvironment === "static") {
          //Testing APAC UAT3
          uploadUrl = "https://sinasebanku2.sg.db.com:8243/digisign/1.0/envelopeMgmt";
          // Testing APAC DEV
          // uploadUrl = "https://pwpbod01.sg.db.com:8243/digisign/1.0/envelopeMgmt";
          // Testing APAC DEV 2
          //uploadUrl = "https://sinasebankd11.sg.db.com:8243/digisign/1.0/envelopeMgmt";
        } else {
          uploadUrl = envitronmentUrl + '/digisign/' + apiversion + '/envelopeMgmt';
        }

        try {
          $.ajax({
            type: 'POST',
            url: uploadUrl,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization-Token': authHeader,
              // Enable for LOCAL Testing
              // 'Authorization': 'Bearer 500b3441f2d85ef7ea618566aa3fd4f5',
            },
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(body),
            success: async function (responseJson) {
              console.log(responseJson);
              if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
                || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
                await set('docsigncenter.documentUploadStatus', true);
              } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
                || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
                // "Data not found in database",
                await set('docsigncenter.documentUploadStatus', responseJson.message);
              } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_FAILED_INT
                || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_FAILED) {
                // "DMS upload operation failed",
                await set('docsigncenter.documentUploadStatus', responseJson.message);
              } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.BASE64_CONVERSION_FAILED_INT
                || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.BASE64_CONVERSION_FAILED) {
                // "PDF data to base64 conversion failed",
                await set('docsigncenter.documentUploadStatus', responseJson.message);
              } else if (responseJson.returnCode === DOCSIGN_API_ERROR_CODES.PDF_MISSING_ANCHOR_TAG_INT
                || responseJson.returnCode === DOCSIGN_API_ERROR_CODES.PDF_MISSING_ANCHOR_TAG) {
                // "PDF File Don't have Anchor String",
                await set('docsigncenter.documentUploadStatus', responseJson.message);
              } else {
                // "Generic error",
                await set('docsigncenter.documentUploadStatus', "error");
              }
              // {"returnCode":0,"message":null,"data":null}

            }.bind(this),
            error: async function (request, status, error) {
              //Failed upload 
              await set('docsigncenter.documentUploadStatus', "error");
            }.bind(this)
          });

        } catch (e) {
          //could not execute ajax
          await set('docsigncenter.documentUploadStatus', "error");
        }
      },
    })
    .path('docsigncenter.resetDocumentStatus', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.documentUploadStatus', undefined);
      }
    })
    .path('docsigncenter.resetEligibleClientList', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.eligibleClientList', undefined);
      }
    })
    .path('docsigncenter.setPageParams', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.pageNumber', req.args[0].pageNumber);
        await set('docsigncenter.pageOffset', req.args[0].pageOffset);
        if (req.args[0].firstTime === false) {
          await call('docsigncenter.updateShouldRequestDocList', true);
        }

      }
    })
    .path('docsigncenter.setSortParams', {
      call: async ({ req }, { get, set, call }) => {
        await set('docsigncenter.sortColumnIndex', req.args[0].sortColumnIndex);
        await set('docsigncenter.sortDirection', req.args[0].sortDirection);
        if (req.args[0].totalPages > 1 && req.args[0].firstTime === false) {
          await call('docsigncenter.updateShouldRequestDocList', true);
        }
      }
    })
    .path('docsigncenter.updateShouldRequestDocList', {
      call: async ({ req }, { get, set, call }) => {
        if (req.args[0] === true || req.args[0] === false) {
          await set('docsigncenter.shouldRequestDocList', req.args[0]);
        }
      }
    })
    .path('docsigncenter.updateExcelExportFlag', {
      call: async ({ req }, { get, set, call }) => {
        if (req.args[0] === true || req.args[0] === false) {
          await set('docsigncenter.excelExportFlag', req.args[0]);
          if (req.args[0] === true) {
            await call('docsigncenter.updateShouldRequestDocList', true);
          }
        }
      }
    })
    .path('docsigncenter.setFilterOptions', {
      call: async ({ req }, { get, set, call }) => {
        if (req.args[0] !== undefined) {
          await set('docsigncenter.filterOptions', req.args[0]);
          if (req.args[1] === false) {
            await call('docsigncenter.updateShouldRequestDocList', true);
          }
        }
      }
    })

    .path('docsigncenter.getRmTeamList', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const banner = 'eSignature';
        const inputs = `${banner}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getRmTeamList["${inputs}"]["${guidStr}"]`));
        if (result == null) {
          await set('docsigncenter.rmTeamList', EMPTY_STRING);
        } else {
          isValidJsonString(result).then(async (getRmTeamListResponse) => {
            if (getRmTeamListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
              || getRmTeamListResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docsigncenter.rmTeamList', getRmTeamListResponse.data);
            } else {
              await set('docsigncenter.rmTeamList', EMPTY_STRING);
            }
          }).catch(async (error) => {
            alert('Response json is not valid ' + error);
          });
        }
      }
    })

    .path('docsigncenter.searchRmName', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();

        const rmName = "F" + req.args[0];
        const pageNumber = "F" + req.args[1];
        const pagesize = "F" + req.args[2];
        const inputs = `${rmName}#@#${pageNumber}#@#${pagesize}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.searchRmName["${inputs}"]["${guidStr}"]`));

        if (result == null) {
          await set('docsigncenter.searchedRmNameList', EMPTY_STRING);
        } else {
          isValidJsonString(result).then(async (res) => {
            if (res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docsigncenter.searchedRmNameList', res.data);
            } else if (res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
              // "Data not found in database",
              await set('docsigncenter.searchedRmNameList', EMPTY_STRING);
            } else {
              await set('docsigncenter.searchedRmNameList', EMPTY_STRING);
            }
          }).catch(async (error) => {
            alert('Response json is not valid ' + error);
          });
        }
      }
    })

    .path('docsigncenter.searchClientName', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();

        const clientName = "F" + req.args[0];
        const pageNumber = "F" + req.args[1];
        const pagesize = "F" + req.args[2];
        const inputs = `${clientName}#@#${pageNumber}#@#${pagesize}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.searchClientName["${inputs}"]["${guidStr}"]`));

        if (result == null) {
          await set('docsigncenter.searchedClientNameList', EMPTY_STRING);
        } else {
          isValidJsonString(result).then(async (res) => {
            if (res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docsigncenter.searchedClientNameList', res.data);
            } else if (res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
              // "Data not found in database",
              await set('docsigncenter.searchedClientNameList', EMPTY_STRING);
            } else {
              alert('Response json returned non-success response');
            }
          }).catch(async (error) => {
            alert('Response json is not valid ' + error);
          });
        }
      }
    })

    .path('docsigncenter.searchOrderId', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();

        const orderId = "F" + req.args[0];
        const pageNumber = "F" + req.args[1];
        const pagesize = "F" + req.args[2];
        const inputs = `${orderId}#@#${pageNumber}#@#${pagesize}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.searchOrderId["${inputs}"]["${guidStr}"]`));

        if (result == null) {
          await set('docsigncenter.searchedOrderIdList', EMPTY_STRING);
        } else {
          isValidJsonString(result).then(async (res) => {
            if (res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docsigncenter.searchedOrderIdList', res.data);
            } else if (res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
              // "Data not found in database",
              await set('docsigncenter.searchedOrderIdList', EMPTY_STRING);
            } else {
              alert('Response json returned non-success response');
            }
          }).catch(async (error) => {
            alert('Response json is not valid ' + error);
          });
        }
      }
    })

    .path('docsigncenter.searchDocumentName', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const orderId = "F" + req.args[0];
        const pageNumber = "F" + req.args[1];
        const pagesize = "F" + req.args[2];
        const inputs = `${orderId}#@#${pageNumber}#@#${pagesize}`;

        const [result] = await getValues(get(`${DOCSIGN_PATH}.searchDocumentName["${inputs}"]["${guidStr}"]`));
        if (result == null) {
          await set('docsigncenter.searchedDocumentNameList', EMPTY_STRING);
        } else {
          isValidJsonString(result).then(async (res) => {
            if (res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docsigncenter.searchedDocumentNameList', res.data);
            } else if (res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT
              || res.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
              // "Data not found in database",
              await set('docsigncenter.searchedDocumentNameList', EMPTY_STRING);
            } else {
              alert('Response json returned non-success response');
            }
          }).catch(async (error) => {
            alert('Response json is not valid ' + error);
          });
        }
      }
    })

    .path('docsigncenter.documentTypeList', variable())
    .path('docsigncenter.eligiblePfList', variable())
    .path('docsigncenter.eligibleClientList', variable())
    .path('docsigncenter.documentListForAdmin', variable())
    .path('docsigncenter.userDocumentStatus', variable())
    .path('docsigncenter.documentContentsForAdmins', variable())
    .path('docsigncenter.documentUploadStatus', variable())
    .path('docsigncenter.documentDownloadStatus', variable())
    .path('docsigncenter.downloadCompleteStatus', variable())
    .path('docsigncenter.pageNumber', variable())
    .path('docsigncenter.pageOffset', variable())
    .path('docsigncenter.sortColumnIndex', variable())
    .path('docsigncenter.sortDirection', variable())
    .path('docsigncenter.shouldRequestDocList', variable(false))
    .path('docsigncenter.excelExportFlag', variable(false))
    .path('docsigncenter.documentListForAdminAll', variable())
    .path('docsigncenter.rmTeamList', variable())
    .path('docsigncenter.signedDate', variable(null))
    .path('docsigncenter.uploadDate', variable(null))
    .path('docsigncenter.dueDate', variable(null))
    .path('docsigncenter.searchedRmNameList', variable())
    .path('docsigncenter.searchedClientNameList', variable())
    .path('docsigncenter.searchedOrderIdList', variable())
    .path('docsigncenter.searchedDocumentNameList', variable())
    .path('docsigncenter.filterOptions', variable())
    .path('docsigncenter.retainFilterData', variable());
